<template>
  <div style="height: 100%;">
    <top-navbar :toggleZapiranjeCounter="toggleZapiranjeCounter">
    </top-navbar>
    <div class="main-panel-parent">
      <side-bar v-on:zapiranjeMenija="zapiranjeMenija"
                type="sidebar" :sidebar-links="$sidebar.sidebarLinks" class="sidebar-style">
      </side-bar>
      <div class="main-panel">
        <dashboard-content @click.native="toggleSidebar">
        </dashboard-content>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import DashboardContent from './Content.vue'
  import {UserInfoAgent} from '../../../assets/js/globalne_funkcije/MixinGetSap'

  export default {
    mixins: [UserInfoAgent],
    data () {
      return {
        toggleZapiranjeCounter: 0
      }
    },
    beforeMount () {
      this.GetUserInfo()
    },
    components: {
      TopNavbar,
      DashboardContent
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      zapiranjeMenija () {
        this.toggleZapiranjeCounter++
      }
    }
  }
</script>
<style>
  /*.sidebar-style {*/
  /*  top: 89px;*/
  /*  position: fixed;*/
  /*}*/

  /*@media screen and (min-width: 0px) and (max-width: 769px) {*/
  /*  .sidebar {*/
  /*    top: 70px !important;*/
  /*  }*/
  /*}*/

  /*@media screen and (max-width: 1000px) {*/
  /*  .sidebar {*/
  /*    top: 80px !important;*/
  /*    left: -1px;*/
  /*  }*/
  /*}*/

  /*@media screen and (min-width: 1001px) {*/
  /*  .sidebar {*/
  /*    top: 89px !important;*/
  /*  }*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue